import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NeptingPaymentModalComponent } from './nepting-payment.page';
import { SharedModuleModule } from '../../shared-module/shared-module.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: NeptingPaymentModalComponent,
			},
		]),
		SharedModuleModule,
	],
	declarations: [NeptingPaymentModalComponent],
})
export class NeptingPaymentPageModule {}
